
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/minha-black-friday/jogo-da-economia",
      function () {
        return require("private-next-pages/minha-black-friday/jogo-da-economia.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/minha-black-friday/jogo-da-economia"])
      });
    }
  